const Home = () => {
  return (
    <div className='home'>
      <h2>This page is currently being developed.</h2>
      <p>Remember to stay hydrated!</p>
    </div>
  );
}

export default Home;